import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class M2Df2ScaffoldService {

  constructor() { }
}
